export function percentageIncrease(original, newValue) {
  if (original === 0) {
    if (newValue === 0) return 0;
    if (newValue > 0) return Infinity;
    return -Infinity;
  }

  return ((newValue - original) / original) * 100;
}

export function mapBetweenRanges(value, minA, maxA, minB, maxB) {
  const aSize = maxA - minA;
  const bSize = maxB - minB;
  const proportion = (value - minA) / aSize;
  return proportion * bSize + minB;
}
